/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵb} from './tab-pane/tab-pane.props';
export {registerProps as ɵa} from './tabs.props';